import { render } from "./AppLoader.vue?vue&type=template&id=3853cb3e"
import script from "./AppLoader.vue?vue&type=script&lang=js"
export * from "./AppLoader.vue?vue&type=script&lang=js"

import "./AppLoader.vue?vue&type=style&index=0&id=3853cb3e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__